// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-default/index.css'
import locale from 'element-ui/lib/locale/lang/en'
import router from './router'
import store from './store'
import './api'
import { urls } from '@js'
import plugins from './plugins'

Vue.use(plugins)
Vue.use(ElementUI, { locale })

const vm = new Vue({
	el: '#app',
	router,
	store,
	template: '<App/>',
	components: { App }
})

//用户权限控制
router.beforeEach((to, from, next) => {
	/*next()  //阻止路由刷新的跳转控制
	return*/

	// debug
	if (to.query.test === 'open') {
		next()
		return
	}
	// debug

	if (to.path == '/FAQ' || to.path == '/POLICY') {//FAQ和POLICY页面，没有权限控制。
		next()
		return
	}
	window.scrollTo(0, 0)


	vm.$http.get('/index/islogin')
		.then(d => {
			vm.$store.commit('update_login_status', d.data.res)

			if (d.data && d.data.code == '75000' && d.data.res.is_login) {//登录状态
				//alert('main success')

				let state = d.data.res.status //大状态

				let exact_state = d.data.res.exact_status //精准状态
				vm.$store.commit('update_login_state', d.data.res.is_login)//更新登录状态
				
				let nextReset = () => next('/login_status')
				// let nextReset = () => next(false)

				if (to.path == '/resetcode' || to.path == '/login_status') {
					//用户登陆状态去改密码，登录页面(后台免登陆)，跳过权限判断
					next()
					return
				}
				
				if (to.path == '/' || to.path == '/rigister') {//登陆状态不允许访问注册页面
					next(false)
					return
				}
				
				if (state == 'interview') {//大模块包含小模块：根据大状态以及精准状态跳转
					if (
						to.path == '/interview' ||
						to.path == '/interview_result' ||
						to.path == '/book_interview' ||
						to.path == '/pending' ||
						to.path == '/interview_pass'
					) {
						//interview允许跳转，否则阻止；以下同理
						if (
							from.path == '/interview_result' ||
							from.path == '/pending' ||
							from.path == '/interview_pass' ||
							// (from.path == '/interview' && to.path == '/book_interview')
							from.path == '/interview'
						) {
							//有些页面不允许后退，加入控制
							nextReset()
						} else {
							next();
						}
					} else {
						nextReset()
					}

					return
				}
				
				if (state == 'tpg') {
					if (
						to.path == '/tpg' ||
						to.path == '/book_tpg' ||
						to.path == '/interview_result' ||
						to.path == '/pending' ||
						to.path == '/tpg_result'
					) {
						if (
							from.path == '/pending' ||
							from.path == '/tpg_result' ||
							// (from.path == '/tpg' && to.path == '/book_tpg')
							from.path == '/tpg'
						) {
							//从tpg_result页面到pending页面后，不允许后退
							nextReset()
						} else {
							next()
						}
					} else {
						nextReset()
					}

					return
				}
				
				if (state == 'demo') {
					if (
						to.path == '/demo' ||
						to.path == '/book_demo' ||
						to.path == '/tpg_result' ||
						to.path == '/pending' ||
						to.path == '/demo_result'
					) {
						if (
							from.path == '/pending' ||
							from.path == '/demo_result' ||
							// (from.path == '/demo' && to.path == '/demo_tpg')
							from.path == '/demo'
						) {
							//从demo_result页面到pending页面后，不允许后退
							nextReset()
						} else {
							next()
						}
					} else {
						nextReset()
					}

					return
				}
				
				if (state == 'onboarding') {
					if (
						to.path == '/personal_profile/personal_in' ||
						to.path == '/personal_profile/personal_qa' ||
						to.path == '/personal_profile/payment' ||
						to.path == '/personal_profile/on_board' ||
						to.path == '/personal_profile/sign_sa' ||
						to.path == '/online_pending' ||
						to.path == '/online_failed'
					) {
						next()
					} else {
						nextReset()
					}

					return
				}
				
				if (state == 'end') {
					if (to.path == '/online_pending' || to.path == '/online_failed' || to.path == '/get_started') {
						next()
					} else {
						nextReset()
					}

					return
				} 
				
			//大模块不包含小模块
				/*这里出现了死循环，是由于当状态在以下当中；路由刷新,触发此方法,进入对应页面，又使路由刷新触发此方法；不加next，导致路由失败*/
				//next()
				if (to.path == '/pso' && state != 'pso') {//当状态不在pso，只阻止一个pso访问，其他页面允许
					nextReset()
				} else {
					next()
				}
				
			} else {//未登录状态
				next()
				//alert('main error')
				vm.$store.commit('update_login_state', false)//更新登录状态

				if (
					to.name != 'rigister_init' &&
					to.name != 'rigister' &&
					to.name != 'privacy_policy' &&
					to.name != 'forgot_password_step1' &&
					to.name != 'forgot_password_step2' &&
					to.name != 'forgot_password_step3' &&
					to.name != 'forgot_password_step4' &&
					to.name != 'FAQ' &&
					to.name != 'POLICY'
				) {//未登录状态访问注册页面
					window.location.href = urls.ssoLogin
				}
			}
		})
})



// WEBPACK FOOTER //
// ./src/main.js